import React, { Component } from 'react';
import './profile.css';
import axios from 'axios';
import ProfileRedeem from './profileredeem';
import ProfileAddDeal from './profileadddeal';
import ProfileSettings from './profilesettings';

class Profile extends Component {

  constructor(props) {
      super(props);
      this.state = {
        display: "redeem"

      }
      this.settingsButton=this.settingsButton.bind(this);
      this.redeemButton=this.redeemButton.bind(this);
      this.addDealsButton=this.addDealsButton.bind(this);

    }
    settingsButton(){
      this.setState({display: "settings"})
    }

    redeemButton(){
      this.setState({display: "redeem"})
    }

    addDealsButton(){
      this.setState({display: "addDeals"})
    }


  render() {
    var display=this.state.display;
    var displayComponent;
    if (display==="redeem") { displayComponent=<ProfileRedeem />}
    else if (display==="settings") {displayComponent=<ProfileSettings />}
    else {displayComponent=<ProfileAddDeal/>}

    return (
    <div className="profile-container">
      <div className="profile-nav">
        <button onClick={this.redeemButton} className="profile-nav-button">Redeem</button>
        <button onClick={this.addDealsButton} className="profile-nav-button">Add Deals</button>
        <button onClick={this.settingsButton} className="profile-nav-button">Settings</button>
      </div>
      <div className="main-profile">
        {displayComponent}
      </div>
    </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/profile.js